var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9999 19V17H5.9999V10C5.9999 9.45 6.07074 8.90833 6.2124 8.375C6.35407 7.84167 6.56657 7.33333 6.8499 6.85L8.3499 8.35C8.23324 8.61667 8.14574 8.8875 8.0874 9.1625C8.02907 9.4375 7.9999 9.71667 7.9999 10V17H14.1999L1.3999 4.2L2.7999 2.8L21.1999 21.2L19.7999 22.6L16.1499 19H3.9999ZM17.9999 15.15L15.9999 13.15V10C15.9999 8.9 15.6082 7.95833 14.8249 7.175C14.0416 6.39167 13.0999 6 11.9999 6C11.5666 6 11.1499 6.06667 10.7499 6.2C10.3499 6.33333 9.98324 6.53333 9.6499 6.8L8.1999 5.35C8.53324 5.08333 8.89157 4.85 9.2749 4.65C9.65824 4.45 10.0666 4.3 10.4999 4.2V3.5C10.4999 3.08333 10.6457 2.72917 10.9374 2.4375C11.2291 2.14583 11.5832 2 11.9999 2C12.4166 2 12.7707 2.14583 13.0624 2.4375C13.3541 2.72917 13.4999 3.08333 13.4999 3.5V4.2C14.8332 4.53333 15.9166 5.2375 16.7499 6.3125C17.5832 7.3875 17.9999 8.61667 17.9999 10V15.15ZM11.9999 22C11.4499 22 10.9791 21.8042 10.5874 21.4125C10.1957 21.0208 9.9999 20.55 9.9999 20H13.9999C13.9999 20.55 13.8041 21.0208 13.4124 21.4125C13.0207 21.8042 12.5499 22 11.9999 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.be7a26aaa7385d3c3cd72d4e8fc52a45.svg";
export { ForwardRef as ReactComponent };